var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "artwork"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M19.9048 0.5H2.09524C0.93807 0.5 0 1.45513 0 2.63333V14.3667C0 15.5449 0.93807 16.5 2.09524 16.5H19.9048C21.0619 16.5 22 15.5449 22 14.3667V2.63333C22 1.45513 21.0619 0.5 19.9048 0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25843 5.80482C6.18929 6.44055 5.99233 6.89922 5.76186 6.89922C5.53138 6.89922 5.33443 6.44055 5.26529 5.80482C4.64091 5.73442 4.19043 5.53389 4.19043 5.29922C4.19043 5.06455 4.64091 4.86402 5.26529 4.79362C5.33443 4.15789 5.53138 3.69922 5.76186 3.69922C5.99233 3.69922 6.18929 4.15789 6.25843 4.79362C6.88281 4.86402 7.33329 5.06455 7.33329 5.29922C7.33329 5.53389 6.88281 5.73442 6.25843 5.80482Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7347 13.2716C16.6656 13.9073 16.4687 14.366 16.2382 14.366C16.0077 14.366 15.8107 13.9073 15.7416 13.2716C15.1172 13.2012 14.6667 13.0007 14.6667 12.766C14.6667 12.5313 15.1172 12.3308 15.7416 12.2604C15.8107 11.6247 16.0067 11.166 16.2382 11.166C16.4687 11.166 16.6656 11.6247 16.7347 12.2604C17.3591 12.3308 17.8096 12.5303 17.8096 12.766C17.8096 13.0007 17.3591 13.2012 16.7347 13.2716Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.5H11V16.5H0V8.5Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0.5H22V8.5H11V0.5Z",
    fill: "#F93939"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4315_1935"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanama);
export default __webpack_public_path__ + "static/media/panama.b0bec691568272cc4b46d06a999ed1a8.svg";
export { ForwardRef as ReactComponent };